import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, getHeaders } from '@urc-ui/store/api/base';
import { HttpMethod } from '@urc-ui/store/api/types';
import {
  GetSubscriptionMigrationStatusRequest,
  GetSubscriptionMigrationStatusResponse,
  InitiateMigrationRequest
} from '@urc-ui/store/api/migration/types';

export const migrationApi = createApi({
  reducerPath: 'migrationApi',
  baseQuery: axiosBaseQuery({
    baseUrl: '/reports/api'
  }),
  endpoints: builder => ({
    initiateMigration: builder.mutation<void, InitiateMigrationRequest>({
      query: (request: InitiateMigrationRequest) => ({
        url: '/migration/initiate',
        method: HttpMethod.POST,
        data: request,
        headers: getHeaders()
      })
    }),
    getSubscriptionMigrationStatus: builder.query<GetSubscriptionMigrationStatusResponse, GetSubscriptionMigrationStatusRequest>({
      query: (request: GetSubscriptionMigrationStatusRequest) => ({
        url: '/migration/status/subscriptions',
        method: HttpMethod.POST,
        data: request,
        headers: getHeaders()
      })
    })
  })
});

export const { useInitiateMigrationMutation, useGetSubscriptionMigrationStatusQuery, useLazyGetSubscriptionMigrationStatusQuery } =
  migrationApi;
